import React from 'react';
import imgDataLeak from '../../../assets/img/dataleak.jpg';
import imgDdos from '../../../assets/img/ddos.png';
import imgRansomware from '../../../assets/img/ransomware.jpg';

export default function Risks() {
  const styles = {
    heading: {
      color: 'white',
      fontSize: '2.5em',
      marginBottom: '30px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
    },
    riskLayout: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '40px',
      maxWidth: '100%',
      margin: '0 auto',
      padding: '0 20px'
    },
    riskImage: {
      width: '350px',
      height: '250px',
      borderRadius: '10px',
      objectFit: 'cover',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      flexShrink: 0
    },
    riskContent: {
      flex: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '10px',
      padding: '25px',
      border: '1px solid rgba(78, 205, 196, 0.3)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      maxWidth: 'calc(100% - 390px)'
    },
    riskTitle: {
      color: '#4ecdc4',
      fontSize: '1.6em',
      fontWeight: 'bold',
      marginBottom: '15px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    riskDescription: {
      color: 'white',
      fontSize: '1em',
      lineHeight: '1.5',
      marginBottom: '20px'
    },
    riskStats: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    },
    statItem: {
      backgroundColor: 'rgba(78, 205, 196, 0.1)',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid rgba(78, 205, 196, 0.3)'
    },
    statNumber: {
      color: '#ff6b6b',
      fontSize: '1.4em',
      fontWeight: 'bold',
      marginBottom: '3px'
    },
    statLabel: {
      color: 'white',
      fontSize: '0.9em',
      marginBottom: '3px'
    },
    statSource: {
      color: '#4ecdc4',
      fontSize: '0.8em',
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    attacksSection: {
      backgroundColor: 'rgba(78, 205, 196, 0.1)',
      padding: '30px',
      borderRadius: '15px',
      margin: '30px auto',
      maxWidth: '1000px',
      border: '2px solid rgba(78, 205, 196, 0.3)'
    },
    attacksTitle: {
      color: '#4ecdc4',
      fontSize: '1.8em',
      textAlign: 'center',
      marginBottom: '20px'
    },
    attackCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      padding: '20px',
      borderRadius: '10px',
      margin: '15px 0',
      border: '1px solid rgba(78, 205, 196, 0.2)',
      transition: 'all 0.3s ease'
    },
    attackName: {
      color: '#4ecdc4',
      fontSize: '1.3em',
      fontWeight: 'bold',
      marginBottom: '10px'
    },
    attackDescription: {
      color: 'white',
      fontSize: '1em',
      lineHeight: '1.4',
      marginBottom: '15px'
    },
    attackImpact: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    impactBadge: {
      backgroundColor: '#ff6b6b',
      color: 'white',
      padding: '5px 10px',
      borderRadius: '15px',
      fontSize: '0.9em',
      fontWeight: 'bold'
    },
    yearBadge: {
      backgroundColor: '#4ecdc4',
      color: 'white',
      padding: '5px 10px',
      borderRadius: '15px',
      fontSize: '0.9em',
      fontWeight: 'bold'
    }
  };

  const risksData = [
    {
      title: 'Exfiltration de données',
      description:
        "Fuite non autorisée d'informations sensibles vers des acteurs malveillants.",
      img: imgDataLeak,
      stats: {
        cost: '$4.88M',
        costSource: 'IBM Cost of Data Breach 2024',
        costUrl: 'https://www.ibm.com/reports/data-breach',
        frequency: '95%',
        frequencyLabel: 'des incidents dus à des erreurs humaines',
        frequencySource: 'IBM Security',
        frequencyUrl: 'https://www.ibm.com/reports/data-breach',
        impact: 'Critique'
      },
      icon: '📊'
    },
    {
      title: 'Ransomware',
      description:
        'Attaques qui chiffrent les données et exigent une rançon pour les déchiffrer.',
      img: imgRansomware,
      stats: {
        cost: '$5.13M',
        costSource: 'IBM Cost of Data Breach 2024',
        costUrl: 'https://www.ibm.com/reports/data-breach',
        frequency: '+41%',
        frequencyLabel: "d'augmentation en 2024",
        frequencySource: 'SonicWall',
        frequencyUrl: 'https://www.sonicwall.com/2024-cyber-threat-report/',
        impact: 'Élevé'
      },
      icon: '🔒'
    },
    {
      title: 'Interruption de service',
      description:
        'Les attaques par déni de service (DDoS) perturbant les opérations en saturant les ressources.',
      img: imgDdos,
      stats: {
        cost: '$2.5M',
        costSource: 'Radware DDoS Report 2024',
        costUrl: 'https://www.radware.com/security/ddos-attack-reports/',
        frequency: '+200%',
        frequencyLabel: "d'augmentation des attaques IoT",
        frequencySource: 'Cloudflare',
        frequencyUrl:
          'https://blog.cloudflare.com/ddos-attack-trends-for-2024/',
        impact: 'Moyen'
      },
      icon: '⚡'
    }
  ];

  const knownAttacks = [
    // Attaques récentes (2024-2025)
    {
      name: 'MOVEit (2023)',
      description:
        'Exploitation massive de la vulnérabilité CVE-2023-34362 dans MOVEit Transfer. Plus de 2000 organisations affectées, incluant des agences gouvernementales et des entreprises Fortune 500.',
      impact: '$10B+',
      impactSource: 'Cybersecurity Ventures',
      impactUrl: 'https://cybersecurityventures.com/',
      year: '2023',
      victims: '2000+ orgs',
      victimsSource: 'CISA',
      victimsUrl: 'https://www.cisa.gov/news-events/cybersecurity-advisories'
    },
    {
      name: 'Okta (2023)',
      description:
        "Compromission du fournisseur d'authentification Okta affectant des milliers d'entreprises. Les attaquants ont accédé aux systèmes de support client et aux données sensibles.",
      impact: '$1.2B',
      year: '2023',
      victims: '18k+ clients'
    },
    {
      name: '23andMe (2023)',
      description:
        "Violation de données génétiques de 6,9 millions d'utilisateurs. Les données incluaient des informations génétiques sensibles et des arbres généalogiques.",
      impact: '$500M',
      year: '2023',
      victims: '6.9M users'
    },
    {
      name: 'Microsoft Exchange (2023)',
      description:
        "Exploitation de vulnérabilités zero-day dans Microsoft Exchange Server par des groupes APT chinois, affectant des milliers d'organisations mondiales.",
      impact: '$2.1B',
      year: '2023',
      victims: '30k+ orgs'
    },
    {
      name: 'LastPass (2022-2023)',
      description:
        "Compromission répétée du gestionnaire de mots de passe LastPass, avec vol de coffres-forts chiffrés et données personnelles de millions d'utilisateurs.",
      impact: '$300M',
      year: '2022-2023',
      victims: '25M+ users'
    },
    // Attaques historiques importantes
    {
      name: 'SolarWinds (2020)',
      description:
        "Attaque sophistiquée ciblant le fournisseur SolarWinds. Compromission des mises à jour logicielles permettant l'accès à de nombreuses organisations gouvernementales et entreprises.",
      impact: '$18B',
      year: '2020',
      victims: '18k+ orgs'
    },
    {
      name: 'Stuxnet (2010)',
      description:
        'Ver informatique ciblant spécifiquement les systèmes SCADA. Premier malware conçu pour attaquer des infrastructures industrielles critiques (programme nucléaire iranien).',
      impact: 'N/A',
      year: '2010',
      victims: 'Iran'
    },
    {
      name: 'WannaCry (2017)',
      description:
        'Ransomware exploitant EternalBlue (NSA). Infecté 300 000+ ordinateurs dans 150 pays, paralysant notamment le NHS britannique et de nombreuses entreprises.',
      impact: '$4B',
      impactSource: 'Cybersecurity Ventures',
      impactUrl: 'https://cybersecurityventures.com/',
      year: '2017',
      victims: '300k+ PCs',
      victimsSource: 'Europol',
      victimsUrl: 'https://www.europol.europa.eu/'
    },
    {
      name: 'NotPetya (2017)',
      description:
        "Ransomware destructif attribué à la Russie. Causé 10+ milliards de dollars de dégâts, affectant Maersk, Merck, et d'autres multinationales.",
      impact: '$10B+',
      year: '2017',
      victims: 'Global'
    },
    {
      name: 'Equifax (2017)',
      description:
        "Violation de données de 147 millions d'Américains. Exploitation d'une vulnérabilité Apache Struts non corrigée, compromettant données personnelles et financières.",
      impact: '$1.4B',
      year: '2017',
      victims: '147M users'
    }
  ];

  return (
    <>
      <section>
        <section data-background-color="CadetBlue">
          <h1 style={styles.heading}>
            <span role="img" aria-label="Warning">
              ⚠️
            </span>{' '}
            Les risques cybersécurité
          </h1>
        </section>

        {risksData.map((risk, idx) => (
          <section key={idx}>
            <div style={styles.riskLayout}>
              <img src={risk.img} alt={risk.title} style={styles.riskImage} />
              <div style={styles.riskContent}>
                <h2 style={styles.riskTitle}>
                  <span role="img" aria-label="Icon">
                    {risk.icon}
                  </span>{' '}
                  {risk.title}
                </h2>
                <p style={styles.riskDescription}>{risk.description}</p>
                <div style={styles.riskStats}>
                  <div style={styles.statItem}>
                    <div style={styles.statNumber}>{risk.stats.cost}</div>
                    <div style={styles.statLabel}>Coût moyen</div>
                    <div
                      style={styles.statSource}
                      onClick={() => window.open(risk.stats.costUrl, '_blank')}
                      title="Cliquer pour voir la source">
                      {risk.stats.costSource}
                    </div>
                  </div>
                  <div style={styles.statItem}>
                    <div style={styles.statNumber}>{risk.stats.frequency}</div>
                    <div style={styles.statLabel}>
                      {risk.stats.frequencyLabel}
                    </div>
                    <div
                      style={styles.statSource}
                      onClick={() =>
                        window.open(risk.stats.frequencyUrl, '_blank')
                      }
                      title="Cliquer pour voir la source">
                      {risk.stats.frequencySource}
                    </div>
                  </div>
                  <div style={styles.statItem}>
                    <div style={styles.statNumber}>{risk.stats.impact}</div>
                    <div style={styles.statLabel}>Niveau d'impact</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ))}

        <section>
          <div style={styles.attacksSection}>
            <h2 style={styles.attacksTitle}>
              <span role="img" aria-label="Trophy">
                🏆
              </span>{' '}
              Hall of Fame des Cyberattaques
            </h2>
            <p
              style={{
                color: 'white',
                textAlign: 'center',
                marginBottom: '30px'
              }}>
              Les attaques les plus marquantes de l'histoire de la cybersécurité
            </p>

            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              {knownAttacks.map((attack, idx) => (
                <div key={idx} style={styles.attackCard}>
                  <div style={styles.attackName}>{attack.name}</div>
                  <div style={styles.attackDescription}>
                    {attack.description}
                  </div>
                  <div style={styles.attackImpact}>
                    <div style={styles.impactBadge}>
                      <span role="img" aria-label="Money">
                        💰
                      </span>{' '}
                      {attack.impact}
                      {attack.impactSource && (
                        <div style={{ fontSize: '0.7em', marginTop: '5px' }}>
                          <span
                            style={{
                              color: '#4ecdc4',
                              cursor: 'pointer',
                              textDecoration: 'underline'
                            }}
                            onClick={() =>
                              window.open(attack.impactUrl, '_blank')
                            }
                            title="Cliquer pour voir la source">
                            {attack.impactSource}
                          </span>
                        </div>
                      )}
                    </div>
                    <div style={styles.yearBadge}>
                      <span role="img" aria-label="Calendar">
                        📅
                      </span>{' '}
                      {attack.year}
                    </div>
                    <div style={{ color: '#4ecdc4', fontSize: '0.9em' }}>
                      <span role="img" aria-label="People">
                        👥
                      </span>{' '}
                      {attack.victims}
                      {attack.victimsSource && (
                        <div style={{ fontSize: '0.7em', marginTop: '5px' }}>
                          <span
                            style={{
                              color: '#4ecdc4',
                              cursor: 'pointer',
                              textDecoration: 'underline'
                            }}
                            onClick={() =>
                              window.open(attack.victimsUrl, '_blank')
                            }
                            title="Cliquer pour voir la source">
                            {attack.victimsSource}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
